/* eslint-disable @next/next/no-img-element */
import styled from 'styled-components'
import { Typography } from '@healingpaper/cell'

import CharacterJA from './assets/character_ja.svg'

import DownloadQrcode from '@/app/components/DownloadQrcode'
import FlexRow from '@/components/shared/FlexRow'
import { isCurrentTimeInRange } from '@/utils/date'
import { GLASSIS_MAIN_OPEN_TIME, GLASSIS_TEASER_OPEN_TIME } from '@/features/promotion/constants'
import { useLocales } from '@/shared/hooks/useLocales'

const LargeDownloadBanner = (): JSX.Element => {
  const { isLocale } = useLocales()
  const imageSource = isCurrentTimeInRange({
    from: GLASSIS_TEASER_OPEN_TIME,
    to: GLASSIS_MAIN_OPEN_TIME,
  })
    ? '/images/kr/glassis_splash.webp'
    : '/images/kr/splash.webp'

  return (
    <Container>
      {isLocale.JP && (
        <StyledContainer aria-label="download banner jp">
          <CharacterJA />
          <StyledQRCodeWrapper>
            <DownloadQrcode size={140} level="L" bgColor="transparent" />
          </StyledQRCodeWrapper>
        </StyledContainer>
      )}
      {isLocale.KR && (
        <StyledContainer aria-label="download banner kr">
          <img src={imageSource} alt="2024 brand film" width="100%" height="auto" />
          <FlexRow justify="space-between">
            <StyledTitle type="title2" className="flex-1">
              QR찍고 앱에서
              <br />더 자세히 보기
            </StyledTitle>
            <div aria-label="app download qr area">
              <DownloadQrcode size={140} level="L" bgColor="transparent" aria-label="app download qr code" />
            </div>
          </FlexRow>
        </StyledContainer>
      )}
    </Container>
  )
}

const Container = styled.div`
  position: fixed;
  width: 344px;
`

const StyledTitle = styled(Typography)`
  padding-left: 16px;
`

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const StyledQRCodeWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 108px;
`

export default LargeDownloadBanner
